module.exports = __webpack_public_path__ + "assets/img/clouds.65af105f.svg";